<template>
  <custom-callout
    :border-color="statusColor"
    class-main="mt-3 rounded"
    :controlled="true"
    :opened="data.isOpen"
    @click:open="
      () => {
        onCloseHandler();
        showContractHistoryTab = true;
      }
    "
  >
    <div class="row py-2 mr-md-0">
      <div class="col-12 col-md-3 border-right">
        <div class="mt-3 pt-1" style="display: inline-flex;">
          <div
            :class="`bg-${statusColor}`"
            style="height: 10px !important;
                width: 10px !important;
                border-radius: 20px;
                margin-top: 14px;
                margin-left: 50px;"
          />
          <span
            class="font-16 color-black"
            style="padding-left: 10px; margin-top: 7px;"
          >
            {{ data.contractStatusName }}
          </span>
        </div>

        <div class="mt-3 pt-1" style="margin-left: 70px;">
          <div class="color-gray-6 font-14">Número de Contrato:</div>
          <div class="color-black font-16">
            {{ data.contractNumber }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-9">
        <div class="row pt-2">
          <div class="col-12 col-md-3 pl-4">
            <div>
              <span class="color-gray-6 d-block font-14">Estudiante:</span>
              <span class="font-16 color-black">
                {{ data.studentFullName }} - {{ data.studentSieId }}
              </span>
            </div>
            <div class="mt-2">
              <span class="color-gray-6 d-block font-14">
                Número de Solicitud:
              </span>
              <span class="font-16 color-black">
                {{ data.requestNumber | empty }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-3 pl-4 mt-2 mt-md-0">
            <div>
              <span class="color-gray-6 d-block font-14">
                Servicio / Disciplina:
              </span>
              <span class="font-16 color-black">
                {{ serviceDisciplineName }}
              </span>
            </div>
            <div class="mt-2">
              <span class="color-gray-6 d-block font-14">
                Nombre del Proveedor:
              </span>
              <span class="font-16 color-black">
                {{ data.companyName | capitalize }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-6 pl-4 mt-2 mt-md-0">
            <div class="row">
              <div class="col-12 col-md-6">
                <span class="color-gray-6 d-block font-14">
                  Especialista / Asistente:
                </span>
                <span class="font-16 color-black">
                  {{ specialistOrAssistantNames }}
                </span>
              </div>
              <div class="col-12 col-md-6">
                <div
                  class="d-inline d-md-flex align-items-center justify-content-end mt-2 mt-md-0"
                >
                  <drop-down class="ml-2" :items="actionItems(data)" />
                </div>
              </div>
              <div class="col-12">
                <div class="my-3">
                  <status-badge
                    v-if="data.isRequestCompensatoryApproved"
                    title="Servicio Compensatorio"
                    type="success"
                  />
                  <status-badge
                    v-if="data.isAEEApproved"
                    title="AEE Aprobado"
                    type="success"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <span class="color-gray-6 d-block font-14">
                  Tipo de Firma:
                </span>
                <span class="font-16 color-black">
                  {{ data.electronicsSignature }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #edition>
      <div v-if="showContractHistoryTab" class="p-2 mt-1">
        <div class="bg-white rounded p-md-3 px-md-4">
          <custom-tab class="custom-tabs">
            <custom-tab-item
              active
              lazy
              title="Información Adicional"
              @click="() => $emit('on-open-contract-additional-tab')"
            >
              <contract-additional-information
                :data="data.additionalInformation"
                :service-type-id="data.requestServiceTypeId"
              />
            </custom-tab-item>
            <custom-tab-item
              :active="
                data.viewToDisplay ===
                  contractViewDisplayEnum.CONTRACT_STATUS_HISTORY
              "
              lazy
              title="Historial de Estatus"
              @click="$emit('on-open-status-history-tab')"
            >
              <contract-status-history
                :items="data.contractStatusHistory.data"
                :page-count="data.contractStatusHistory.pageCount"
                @on-load-more="$emit('on-status-history-load-more')"
              />
            </custom-tab-item>
            <custom-tab-item
              :active="
                data.viewToDisplay === contractViewDisplayEnum.CONTRACT_HISTORY
              "
              lazy
              title="Historial de Contrato"
              @click="$emit('on-open-history-tab')"
            >
              <contract-history
                :items="data.contractHistory.data"
                :pagination="data.contractHistory.pagination"
                @on-go-to-page="$emit('on-history-change-page', $event)"
                @on-print="onDownloadContract"
              />
            </custom-tab-item>
            <custom-tab-item
              :active="
                data.viewToDisplay ===
                  contractViewDisplayEnum.CONTRACT_ADDITIONAL_DOCUMENTS
              "
              lazy
              title="Documentos"
              @click="$emit('on-open-documents-tab')"
            >
              <contract-additional-documents
                :data="data"
                @cancel="onCloseHandler"
                @refresh-documents="refreshDocumentsHandler"
              />
            </custom-tab-item>
            <custom-tab-item
              v-if="canViewEvaluationDocumentsTab"
              :active="
                data.viewToDisplay ===
                  contractViewDisplayEnum.EVALUATION_DOCUMENTS
              "
              lazy
              title="Documentos de Evaluación"
              @click="$emit('on-open-evaluation-documents-tab')"
            >
              <contract-evaluation-documents
                :data="data"
                @cancel="onCloseHandler"
                @saved="showCompleteEvaluation = false"
              />
            </custom-tab-item>
            <custom-tab-item
              v-if="canViewVisitDetaialTab"
              :active="
                data.viewToDisplay === contractViewDisplayEnum.VISIT_DETAILS
              "
              lazy
              title="Detalles de Visita"
              @click="$emit('on-open-visit-detail-tab')"
            >
              <visit-detail
                :ignore-moth-filter="true"
                :ignore-specialist-filter="true"
                :item="data"
              />
            </custom-tab-item>
            <custom-tab-item
              v-if="canViewCompensatoryTherapyBalance"
              :active="
                data.viewToDisplay ===
                  contractViewDisplayEnum.COMPENSATORY_THERAPY_BALANCE
              "
              lazy
              title="Balance de Terapias Compensatorias"
              @click="$emit('on-open-compensatory-therapy-balance-tab')"
            >
              <contract-balance-of-therapy-compensatory :data="data" />
            </custom-tab-item>
            <custom-tab-item
              :active="
                data.viewToDisplay ===
                  contractViewDisplayEnum.CONTRACT_DOCUMENT_HISTORY
              "
              lazy
              title="Historial de Documentos"
              @click="$emit('on-open-document-history-tab')"
            >
              <contract-document-history :data="data" />
            </custom-tab-item>
            <custom-tab-item
              v-if="data.isAEE || data.isAEEApproved"
              :active="
                data.viewToDisplay === contractViewDisplayEnum.CONTRACT_AEE
              "
              lazy
              title="AEE"
              @click="$emit('on-open-aee-tab')"
            >
              <contract-request-aee
                v-if="data.requestAee.statusId === isRequestDenied"
                :data="data"
                @on-view-request-aee="openRequestAee()"
              />
              <contract-aee v-else :data="data" />
            </custom-tab-item>

            <custom-tab-item
              v-if="data.compensatoryRequest.isEnabled"
              :active="
                data.viewToDisplay ===
                  contractViewDisplayEnum.COMPENSATORY_REQUEST
              "
              lazy
              title="Servicios Compensatorios"
              @click="$emit('on-open-compensatory-request-tab')"
            >
              <contract-request-compensatory
                :contract="{
                  companyId: data.companyId,
                  contractId: data.contractId,
                  requestServiceId: data.requestServiceId,
                }"
                :items="data.compensatoryRequest.data"
                :pagination="data.compensatoryRequest.pagination"
                @on-go-to-page="
                  $emit('on-compensatory-service-change-page', $event)
                "
              />
            </custom-tab-item>
            <custom-tab-item
              :active="
                data.viewToDisplay ===
                  contractViewDisplayEnum.CONTRACT_COST_CHANGE_HISTORY
              "
              lazy
              title="Historial de Cambios en el Costo"
              @click="$emit('on-open-cost-change-history-tab')"
            >
              <contract-cost-change-history
                :items="data.contractCostChangeHistory.data"
                :page-count="data.contractCostChangeHistory.pageCount"
                @on-load-more="$emit('on-cost-change-history-load-more')"
              />
            </custom-tab-item>
          </custom-tab>
        </div>
      </div>

      <div v-if="showReturnToNewStateTab" class="p-2">
        <div class="bg-white rounded p-md-3 px-md-4">
          <div class="py-3">
            <contract-return-to-new-status
              :data="data"
              @cancel="onCloseHandler"
              @save="onContractStatusReturnedToNew"
            />
          </div>
        </div>
      </div>
      <div v-if="showAssignStartDate" class="p-2">
        <div class="bg-white rounded p-md-3 px-md-4">
          <div class="py-3">
            <contract-assign-start-date
              :contract-assign-start-date-validations="
                contractAssignStartDateValidations
              "
              :data="data"
              :is-editing="!!data.contractServiceStartDate"
              @cancel="onCloseHandler"
              @save="onContractServiceStartDateSave"
            />
          </div>
        </div>
      </div>
      <div
        v-if="
          data.viewToDisplay === contractViewDisplayEnum.MODIFY_APPROVAL_DATE
        "
        class="p-2"
      >
        <div class="bg-white rounded p-md-3 px-md-4">
          <div class="py-3">
            <contract-modify-approval-date
              :data="data"
              @cancel="onCloseHandler"
              @save="onContractServiceStartDateSave"
            />
          </div>
        </div>
      </div>
      <div v-if="showCompleteEvaluation" class="p-2">
        <div class="bg-white rounded p-md-3 px-md-4">
          <div class="pb-2">
            <complete-evaluation
              :data="data"
              @cancel="onCloseHandler"
              @saved="onSavedCompleteEvaluation"
            />
          </div>
        </div>
      </div>
      <div v-if="showCompleteDiscussion" class="p-2">
        <div class="bg-white rounded p-md-3 px-md-4">
          <div class="pb-2">
            <complete-discussion
              :data="data"
              @cancel="onCloseHandler"
              @saved="onSavedCompleteEvaluation"
            />
          </div>
        </div>
      </div>
      <div v-if="showRequestAEE" class="p-2">
        <div class="bg-white rounded p-md-3 px-md-4">
          <div class="pb-2">
            <Request
              :academic-year-id="data.academicYearId"
              :contract-id="data.contractId"
              :request="data.requestAee"
              :request-assign-start-date-validations="
                requestAssignStartDateValidations
              "
              :request-type="1"
              title="Solicitar Año Escolar Extendido"
              @cancel="onCloseHandler"
              @saved="onRequestSaved(data)"
            />
          </div>
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import { CustomTab, CustomTabItem } from 'custom-tabs';

//local components
import {
  ContractAdditionalInformation,
  ContractStatusHistory,
  ContractHistory,
  ContractAdditionalDocuments,
  ContractBalanceOfTherapyCompensatory,
  ContractEvaluationDocuments,
  ContractDocumentHistory,
  ContractAee,
  ContractRequestAee,
  ContractCostChangeHistory,
} from './tabs';

import ContractReturnToNewStatus from './ContractReturnToNewStatus.vue';
import ContractAssignStartDate from './ContractAssignStartDate.vue';
import ContractModifyApprovalDate from './ContractModifyApprovalDate.vue';
import ContractRequestCompensatory from './RequestCompensatoryResultRow.vue';

import CompleteEvaluation from './CompleteEvaluation.vue';
import Request from './Request.vue';
import VisitDetail from '@/views/provider/billing-history-management/components/billDetail/components/VisitDetail.vue';
import CompleteDiscussion from './CompleteDiscussion.vue';
import StatusBadge from './StatusBadge.vue';

//constants
import rpContractStatus, {
  rpContractStatusColor,
} from '@/utils/constants/rpContractStatus.js';
import rpServiceTypes from '@/utils/constants/serviceTypes.js';
import rpRequestStatus from '@/utils/constants/biddingRequestStatus.js';
import contractViewDisplay from '@/utils/constants/contractViewDisplay.js';
import disciplineTypes from '@/utils/constants/disciplineTypes.js';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import utils from '@/utils/utilities';

//services
import { getMinAndMaxContractServiceStartDate as _getMinAndMaxContractServiceStartDate } from '@/services/uspqrp/contract.api.js';
import { validateRequest as _validateRequest } from '@/services/provider/extended-academic-year.api.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import ReportServices from '@/services/common/report.api';

export default {
  name: 'ResultRow',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    DropDown,
    CustomTab,
    CustomTabItem,
    ContractAdditionalInformation,
    ContractStatusHistory,
    ContractReturnToNewStatus,
    ContractHistory,
    ContractAssignStartDate,
    ContractModifyApprovalDate,
    CompleteEvaluation,
    ContractAdditionalDocuments,
    VisitDetail,
    ContractBalanceOfTherapyCompensatory,
    CompleteDiscussion,
    ContractEvaluationDocuments,
    ContractDocumentHistory,
    ContractAee,
    Request,
    ContractRequestAee,
    StatusBadge,
    ContractRequestCompensatory,
    ContractCostChangeHistory,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    canRegisterInterventionPlan: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showReturnToNewStateTab: false,
      showContractHistoryTab: false,
      showContractCostoChangeHistoryTab: false,
      showAssignStartDate: false,
      contractAssignStartDateValidations: {
        minDate: null,
        maxDate: null,
      },
      requestAssignStartDateValidations: {
        minDate: null,
        maxDate: null,
      },
      showContractModifyApprovalDate: false,
      showCompleteEvaluation: false,
      showCompleteDiscussion: false,
      showRequestAEE: false,
    };
  },
  computed: {
    contractStatusId() {
      return this.data.contractStatusId;
    },
    isElectronicSignature() {
      return this.data.isElectronicsSignature ?? false;
    },
    serviceDisciplineName() {
      return ![rpServiceTypes.Assistant, rpServiceTypes.Nurse].includes(
        this.data.requestServiceTypeId
      )
        ? this.data.disciplineTypeName
          ? `${this.data.requestServiceTypeName} - ${this.data.disciplineTypeName}`
          : this.data.requestServiceTypeName
        : this.data.disciplineTypeName;
    },
    statusColor() {
      const hashMap = {
        [rpContractStatus.New]: rpContractStatusColor[rpContractStatus.New],
        [rpContractStatus.Submitted]:
          rpContractStatusColor[rpContractStatus.Submitted],
        [rpContractStatus.Approved]:
          rpContractStatusColor[rpContractStatus.Approved],
        [rpContractStatus.Denied]:
          rpContractStatusColor[rpContractStatus.Denied],
        [rpContractStatus.ApprovedContractInformation]:
          rpContractStatusColor[rpContractStatus.ApprovedContractInformation],
        [rpContractStatus.DeniedContractInformation]:
          rpContractStatusColor[rpContractStatus.DeniedContractInformation],
        [rpContractStatus.Signed]:
          rpContractStatusColor[rpContractStatus.Signed],
        [rpContractStatus.ContractCanceled]:
          rpContractStatusColor[rpContractStatus.ContractCanceled],
        [rpContractStatus.ContractAmended]:
          rpContractStatusColor[rpContractStatus.ContractAmended],
        [rpContractStatus.InSigningProcess]:
          rpContractStatusColor[rpContractStatus.SignatureProcess],
      };
      return hashMap[this.data.contractStatusId ?? rpContractStatus.Unset];
    },
    actionItems() {
      return (item) => {
        const isEditingContractServiceStartDate = !!item.contractServiceStartDate;
        const hasContractDeterminationDate = !!item.contractDeterminationDate; // this is the approval date

        return [
          {
            label: 'Ver Contrato',
            icon: 'fas fa-file-import color-green',
            click: () => this.$emit('on-view-contract'),
          },
          {
            label: 'Imprimir Contrato',
            icon: 'fas fa-print color-green',
            visible: this.canDownloadContract,
            click: () => this.onDownloadContract(this.data),
          },
          {
            label: 'Imprimir Contrato en Blanco',
            icon: 'fas fa-solid fa-file color-green',
            visible: this.canDownloadEmptyContract,
            click: () => this.onDownloadEmptyContract(this.data),
          },
          {
            label: 'Información Adicional',
            icon: 'fas fa-info-circle color-green',
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = true;
              this.$emit('on-open-contract-additional-tab');
            },
            border: 'top',
            visible: true,
          },
          {
            label: 'Historial de Estatus',
            icon: 'fas fa-clock color-green',
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = true;
              this.$emit('on-open-status-history-tab');
            },
            visible: true,
          },
          {
            label: 'Historial de Contrato',
            icon: 'fas fa-history color-green',
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = true;
              this.$emit('on-open-contract-history-tab');
            },
            visible: true,
          },
          {
            label: 'Historial de Cambios en el costo',
            icon: 'fas fa-clock color-green',
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = true;
              this.$emit('on-open-cost-change-history-tab');
            },
            visible: true,
          },
          {
            label: 'Detalle de Visitas',
            icon: 'fas fa-user-friends color-green',
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = true;
              this.$emit('on-open-visit-detail-tab');
            },
            visible: this.canViewVisitDetaialTab,
          },
          {
            label: 'Documentos',
            icon: 'fas fa-file-import color-green',
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = true;
              this.$emit('on-open-documents-tab');
            },
            visible: true,
          },
          {
            label: 'Imprimir Carta',
            icon: 'fas fa-file-import color-green',
            visible: false,
            click: () => {},
          },
          {
            label: 'Modificar fecha de aprobación',
            icon: 'fas fa-calendar-day color-green',
            visible: this.canModifyApprovalDate,
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = false;
              this.$emit('on-open-modify-approval-date');
            },
          },
          {
            label: 'Registrar Visitas',
            icon: 'fas fa-user-clock color-green',
            visible:
              this.canViewVisitRegistryAction &&
              isEditingContractServiceStartDate,
            click: () => this.$emit('on-register-visits'),
          },
          {
            label: 'Certificación de Servicios',
            icon: 'fas fa-print color-green',
            visible: this.canViewServiceCertification,
            click: () => this.$emit('on-service-certification'),
          },
          {
            label: 'Balance de Terapias Compensatorias',
            icon: 'fas fa-file-invoice-dollar color-green',
            visible: this.canViewCompensatoryTherapyBalance,
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = true;
              this.$emit('on-open-compensatory-therapy-balance-tab');
            },
          },
          {
            label: 'Documento(s) de Evaluación',
            icon: 'fas fa-file-import color-green',
            visible: this.canViewEvaluationDocuments,
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = true;
              this.$emit('on-open-evaluation-documents-tab');
            },
          },
          {
            label: 'Completar Evaluación',
            icon: 'fas fa-calendar-plus color-green',
            visible: this.canCompleteEvaluation,
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = false;
              this.showCompleteEvaluation = true;
            },
          },
          {
            label: 'Discusión de Evaluación',
            icon: 'fas fa-calendar-plus color-green',
            visible: this.canCompleteDiscussion,
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = false;
              this.showCompleteDiscussion = true;
            },
          },
          {
            label: 'AEE',
            icon: 'fas fa-info-circle color-green',
            visible: item.isAEE,
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = true;
              this.$emit('on-open-aee-tab');
            },
          },
          {
            label: 'Servicios Compensatorios',
            icon: 'fas fa-clipboard-list-check color-green',
            visible:
              item.isTherapyServiceType && item.compensatoryRequest.isEnabled,
            click: () => {
              this.onCloseHandler();
              this.showContractHistoryTab = true;
              this.$emit('on-open-compensatory-request-tab');
            },
          },
          {
            label: 'Solicitar Año Escolar Extendido',
            icon: 'fas fa-solid fa-calendar-arrow-down color-green',
            visible:
              this.canViewCreateRequestAEE &&
              !this.data.isStudentEgressed &&
              !item.isAEE,
            border: 'top',
            click: async () => {
              const payload = {
                contractId: item.contractId,
                academicYearId: item.academicYearId,
                contractParentId: item.contractParentId,
                isAEE: true,
              };

              const { data: result } = await _validateRequest(
                item.contractId
              ).catch((err) => {
                this.ShowToast(
                  'Alerta',
                  err.response.data.message || 'error',
                  'error'
                );
              });

              if (!result.value) {
                this.ShowToast('Alerta', result.message || 'error', 'error');
                return;
              }

              const {
                data: { minDate, maxDate },
              } = await _getMinAndMaxContractServiceStartDate(payload).catch(
                (error) => {
                  this.ShowToast('Alerta', `${error.message}.`, 'error');
                  return { data: false };
                }
              );

              this.requestAssignStartDateValidations.minDate = minDate;
              this.requestAssignStartDateValidations.maxDate = maxDate;

              this.onCloseHandler();
              this.showRequestAEE = true;
            },
          },
          {
            label: 'Regresar Estatus Nuevo',
            icon: 'fas fa-undo color-green',
            visible:
              this.canViewReturnToNewStateAction() &&
              !this.data.isStudentEgressed,
            click: () => {
              this.onCloseHandler();
              this.showReturnToNewStateTab = true;
              this.$emit('on-open-return-to-new-status', false);
            },
          },
          {
            label: 'Regresar Estatus Anterior',
            icon: 'fas fa-undo color-green',
            visible:
              this.canReturnToPreviousStatus && !this.data.isStudentEgressed,
            click: () => {
              this.onCloseHandler();
              this.showReturnToNewStateTab = true;
              this.$emit('on-open-return-to-previous-status', true);
            },
          },
          {
            label: isEditingContractServiceStartDate
              ? 'Modificar Fecha de Comienzo'
              : 'Asignar Fecha de Comienzo',
            icon: 'fas fa-calendar-alt color-green',
            visible:
              hasContractDeterminationDate &&
              this.canAddOrUpdateContractServiceStartDate(
                isEditingContractServiceStartDate
              ),
            click: async () => {
              const payload = {
                contractId: item.contractId,
                academicYearId: item.academicYearId,
                contractParentId: item.contractParentId,
                isAEE: item.isAEE,
              };

              const {
                data: { minDate, maxDate },
              } = await _getMinAndMaxContractServiceStartDate(payload).catch(
                (error) => {
                  this.ShowToast('Alerta', `${error.message}.`, 'error');
                  return { data: false };
                }
              );

              this.contractAssignStartDateValidations.minDate = minDate;
              this.contractAssignStartDateValidations.maxDate = maxDate;

              this.onCloseHandler();
              this.showAssignStartDate = true;
              this.$emit('on-open-return-to-new-status', false);
            },
          },
          {
            label: 'Informe de Progreso',
            icon: 'fas fa-files-medical color-green',
            visible: this.canViewAchievementSummary(),
            click: () => this.$emit('on-view-achievement-summary'),
          },
          {
            label: 'Añadir Plan',
            icon: 'fas fa-files-medical color-green',
            visible: this.canAddInterventionPlan(),
            click: () => this.$emit('on-add-intervention-plan'),
          },
          {
            label: 'Ver Plan',
            icon: 'fas fa-files-medical color-green',
            visible: this.canViewInterventionPlan(),
            click: () => this.$emit('on-add-intervention-plan'),
          },
        ];
      };
    },
    specialistOrAssistantNames() {
      return this.data.specialistOrAssistantList?.length
        ? this.data.specialistOrAssistantList
            .map((x) => this.$options.filters.capitalize(x.name))
            .join(', ')
        : null;
    },
    contractViewDisplayEnum() {
      return contractViewDisplay;
    },
    canReturnToPreviousStatus() {
      const status = [rpContractStatus.New, rpContractStatus.ContractAmended];
      const hasPermission = this.userHasPermissions(
        'rempro.providers.contract.returntopreviousstatus'
      );
      return !status.includes(this.data.contractStatusId) && hasPermission;
    },
    canModifyApprovalDate() {
      const hasPermission = this.userHasPermissions(
        'rempro.providers.contract.modifyapprovaldate'
      );
      return (
        this.canViewActionWithStatus([
          rpContractStatus.ApprovedContractInformation,
        ]) && hasPermission
      );
    },
    canDownloadContract() {
      const status = [
        rpContractStatus.ApprovedContractInformation,
        rpContractStatus.Signed,
        rpContractStatus.ContractAmended,
      ];

      const hasPermission = this.userHasPermissions(
        'rempro.providers.contract.download'
      );
      return status.includes(this.data.contractStatusId) && hasPermission;
    },
    canDownloadEmptyContract() {
      const status = [
        rpContractStatus.Approved,
        rpContractStatus.ApprovedContractInformation,
        rpContractStatus.Signed,
        rpContractStatus.ContractAmended,
        rpContractStatus.InSigningProcess,
      ];

      const hasPermission = this.userHasPermissions(
        'rempro.providers.contract.download'
      );
      return (
        status.includes(this.data.contractStatusId) &&
        hasPermission &&
        !this.isElectronicSignature
      );
    },
    canCompleteEvaluation() {
      return (
        this.userHasPermissions(
          'rempro.providers.contract.completeevaluation'
        ) &&
        //si el contrato es firmado o esta cancelado y fue cancelado por egreso
        (this.data.contractStatusId === rpContractStatus.Signed ||
          (this.data.contractStatusId === rpContractStatus.ContractCanceled &&
            this.data.canceledByEgress)) &&
        this.data.requestServiceTypeId === rpServiceTypes.Evaluation &&
        !this.data.hasBilling
      );
    },
    canViewVisitRegistryAction() {
      var validStatus = [
        rpContractStatus.Signed,
        rpContractStatus.ContractAmended,
        rpContractStatus.ContractCanceled,
      ];
      return (
        this.userHasPermissions(
          'rempro.providers.contract.visitregistry.view'
        ) &&
        validStatus.includes(this.contractStatusId) &&
        !this.isEvaluationOrNurseServiceType
      );
    },
    isEvaluationOrNurseServiceType() {
      return this.data.isEvaluationServiceType;
    },
    canViewCompensatoryTherapyBalance() {
      return this.data.isTherapyCompensatory;
    },
    canCompleteDiscussion() {
      return (
        this.userHasPermissions(
          'rempro.providers.contract.completeevaluationdiscussion'
        ) &&
        this.data.contractStatusId === rpContractStatus.Signed &&
        this.data.requestServiceTypeId === rpServiceTypes.Evaluation &&
        !!this.data.contractServiceStartDate &&
        !this.data.hasCompletedDiscussion
      );
    },
    canViewEvaluationDocuments() {
      return (
        (this.data.contractStatusId === rpContractStatus.Signed &&
          this.data.requestServiceTypeId === rpServiceTypes.Evaluation &&
          this.data.hasCompletedEvaluation) ||
        this.data.hasCompletedDiscussion
      );
    },
    canViewServiceCertification() {
      return (
        [
          rpContractStatus.Signed,
          rpContractStatus.ContractAmended,
          rpContractStatus.ContractCanceled,
        ].includes(this.data.contractStatusId) &&
        this.data.contractServiceStartDate != null &&
        this.data.isEvaluationServiceType &&
        this.hasCompletedEvaluation
      );
    },
    canViewEvaluationDocumentsTab() {
      return this.data.isEvaluationServiceType;
    },
    canViewVisitDetaialTab() {
      return !this.data.isEvaluationServiceType;
    },
    canViewCreateRequestAEE() {
      return (
        this.data.canRequestAEE &&
        this.data.contractStatusId === rpContractStatus.Signed &&
        this.data.requestServiceTypeId !== rpServiceTypes.Evaluation &&
        !this.data.isTherapyCompensatory
      );
    },
    isRequestDenied() {
      return rpRequestStatus.Denied;
    },
  },
  methods: {
    canViewActionWithStatus(statusList) {
      return (statusList ?? []).includes(this.contractStatusId);
    },
    async onDownloadContract({ contractDocumentId }) {
      this.onDownloadFile(contractDocumentId);
    },
    async onDownloadEmptyContract(data) {
      await ReportServices.getReport('contract', {
        contractId: data.contractId,
        serviceTypeId: data.requestServiceTypeId,
        contractNumber: data.contractNumber,
        isAmendment: data.isAmendment,
        isInterpreter: disciplineTypes.Interprete === data.disciplineTypeId,
      })
        .then((res) => utils.convertToBlob(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
          this.isDisabled = false;
        });
    },
    async onContractStatusReturnedToNew(saved) {
      if (saved) {
        this.onCloseHandler();
        this.$emit('on-return-contract-to-new-status');
      }
    },
    onDownloadFile(id) {
      _downloadDocumentByAttachmentId(id).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
    },
    async onContractServiceStartDateSave(saved) {
      if (saved) {
        this.onCloseHandler();
        this.$emit('on-service-start-date-save');
      }
    },
    onCloseHandler() {
      this.showReturnToNewStateTab = false;
      this.showContractHistoryTab = false;
      this.showAssignStartDate = false;
      this.showCompleteEvaluation = false;
      this.showCompleteDiscussion = false;
      this.showRequestAEE = false;
      this.$emit('on-open-close');
    },
    onRequestSaved(item) {
      item.isAEE = true;
    },
    canViewReturnToNewStateAction() {
      const hasAdminPermission =
        this.userHasPermissions(
          'rempro.providers.contract.returntonewstatus.admin'
        ) &&
        (this.contractStatusId ===
          rpContractStatus.ApprovedContractInformation ||
          this.contractStatusId ===
            rpContractStatus.DeniedContractInformation ||
          this.contractStatusId === rpContractStatus.ContractCanceled);
      const hasProviderPermission =
        this.userHasPermissions(
          'rempro.providers.contract.returntonewstatus.provider'
        ) && this.contractStatusId === rpContractStatus.Submitted;
      return hasAdminPermission || hasProviderPermission;
    },
    canAddOrUpdateContractServiceStartDate(isEditing) {
      const hasPermission = isEditing
        ? this.userHasPermissions(
            'rempro.providers.contract.contractservicestartdate.edit'
          )
        : this.userHasPermissions(
            'rempro.providers.contract.contractservicestartdate.add'
          );

      return hasPermission && this.contractStatusId === rpContractStatus.Signed;
    },
    refreshDocumentsHandler() {
      this.$emit('on-refresh-addiotionals-documents');
    },
    onSavedCompleteEvaluation(saved) {
      if (saved) {
        this.onCloseHandler();
        this.$emit('on-open-evaluation-documents-tab', true);
      }
    },
    openRequestAee() {
      this.showContractHistoryTab = false;
      this.showRequestAEE = true;
    },
    canAddInterventionPlan() {
      const existsPlan = (this.data.planId || 0) > 0;
      return (
        this.data.isTherapyServiceType &&
        this.contractStatusId === rpContractStatus.Signed &&
        !existsPlan &&
        this.canRegisterInterventionPlan
      );
    },
    canViewInterventionPlan() {
      const existsPlan = (this.data.planId || 0) > 0;
      const allowedStatus = [
        rpContractStatus.Signed,
        rpContractStatus.ContractAmended,
        rpContractStatus.ContractCanceled,
      ].includes(this.contractStatusId);
      return (
        this.data.isTherapyServiceType &&
        allowedStatus &&
        existsPlan &&
        this.canRegisterInterventionPlan
      );
    },
    canViewAchievementSummary() {
      const existsPlan = (this.data.planId || 0) > 0;
      const allowedStatus = [rpContractStatus.Signed].includes(
        this.contractStatusId
      );
      return this.data.isTherapyServiceType && allowedStatus && existsPlan;
    },
  },
};
</script>
